import { z } from "zod";
import { zCodeListSchema, zString } from "./commonSchemaObjects";

export const deleteReasonSchema = z.object({
    delete_reason: zCodeListSchema,
    delete_comment: zString.zRequired,
});
